jQuery(document).ready(function( $ ){
  $(document).ready(function(){
/*
    if($('.inner')){
      $('.inner').slick({
        infinite: true,
        dots:false,
        arrows:false,
        slidesToShow: 1,
        slidesToScroll: 1,
        Transform: false
      });
    }
      

     
    
  	$('ul.tabs li').click(function(){
  		var tab_id = $(this).attr('data-tab');
  		$('ul.tabs li').removeClass('current');
  		$('.tab-content').removeClass('current');
  		$(this).addClass('current');
  		$("#"+tab_id).addClass('current');
  	});
    

    $(".layer-trigger").click(function(){
       $(".layer-trigger").removeClass("active");
       $(this).addClass("active");
  
       //var slideno = $(this).data('slide');
       //$('.inner').slick('slickGoTo', slideno - 1);
       
    });
  
      $('g[data-slide]').click(function(e) {
         e.preventDefault();
         var slideno = $(this).data('slide');
         $('.inner').slick('slickGoTo', slideno - 1);
      });
      */
      
  });

  

});

new Swiper(".slider_text_review", {
  loop: true,
  spaceBetween: 5,
  // Navigation arrows
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  // Responsive breakpoints
  breakpoints: {
    0: {
      slidesPerView: 2,
    },
    768: {
      slidesPerView: 2,
    },
    1024: {
      slidesPerView: 3,
    },
  },
});

new Swiper(".slider_text_video", {
  loop: true,
  spaceBetween: 4,
  // Navigation arrows
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: '.slider__pagination',
    clickable: true,
  },
  // Responsive breakpoints
  breakpoints: {
    0: {
      slidesPerView: 3,
    },
    768: {
      slidesPerView: 2,
    },
    1024: {
      slidesPerView: 4,
    },
  },
});
